import { Controller, FieldValues, FieldPath, Control } from "react-hook-form";
import { Checkbox, CheckboxProps } from "../ui/checkbox";

interface ControlledCheckboxProps<T extends FieldValues> extends CheckboxProps {
    name: FieldPath<T>;
    control: Control<T>;
};

const ControlledCheckbox = <T extends FieldValues>(props: ControlledCheckboxProps<T>) => {
    const { control, name, ...checkboxProps } = props;
	return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Checkbox
                    checked={field.value as boolean}
                    onCheckedChange={field.onChange}
                    {...checkboxProps}
                />
            )}
        />
)};

export { ControlledCheckbox };